import { CreativeTagEvent } from '../enums';
import { AdContainer } from '../ad-container/ad-container';
import { ExperienceEntryPoint } from '../static-media-entry-point/experience-entry-point';
import { Tracking, TrackingClick } from '../types/experience';

export class ClickActionHandler {
  constructor(
    private readonly experienceEntryPoint: ExperienceEntryPoint,
    private readonly adContainer: AdContainer
  ) {
    this.attachEvents();
  }

  private attachEvents() {
    this.experienceEntryPoint.addEventListener(
      CreativeTagEvent.CreativeClicked,
      this.onCreativeClicked.bind(this)
    );
  }

  protected onCreativeClicked(): void {
    const {
      clickUrls,
      isSmartCommerce,
      calendarDestinationUrls,
      calendarClicks,
      deviceOS
    } = this.experienceEntryPoint;

    if (!clickUrls || isSmartCommerce) {
      return;
    }

    const calendarUrl = this.getCalendarUrl(
      calendarClicks,
      calendarDestinationUrls,
      deviceOS
    );

    if (calendarUrl) {
      this.adContainer.open(calendarUrl);
    } else if (clickUrls.urlToOpen) {
      this.adContainer.open(clickUrls.urlToOpen);
    }

    if (!clickUrls.pixelUrl) {
      return;
    }
    const img = new Image();
    img.src = clickUrls.pixelUrl;
  }

  private getCalendarUrl(
    calendarClicks: TrackingClick[] | undefined,
    calendarDestinationUrls: Tracking['calendarDestinationUrls'] | undefined,
    deviceOS: string | undefined
  ): string | undefined {
    const normalizedDeviceOS = deviceOS === 'ios' ? 'ios' : 'android';

    if (calendarClicks?.length) {
      const matchByOs = calendarClicks.find(
        ({ type, deviceOS: os }) =>
          type === 'calendar' && (os ?? 'android') === normalizedDeviceOS
      );

      if (matchByOs?.url) {
        return matchByOs.url;
      }
    }

    if (!calendarDestinationUrls?.length) {
      return undefined;
    }
    const deviceCalendarType = normalizedDeviceOS === 'ios' ? 'IOS' : 'ANDROID';

    return calendarDestinationUrls.find(
      ({ calendarType }) => calendarType === deviceCalendarType
    )?.url;
  }
}
